import { RefrigerantTypeService } from './refrigerant-type.service';
import { PerimetersService } from './perimeters.service';
import { APIService } from './../api/api.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KPI } from '../api';
import { map, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PerimeterEnergyTrajectoryService {

  constructor(
    private apiService: APIService,
    private refrigerantTypeService: RefrigerantTypeService,
    private perimetersService: PerimetersService,
  ) {
    this.perimetersService._perimetersHaveChanged$.subscribe(() => {
      this._perimeterEnergyTrajectories = {};
      this._refrigerantPerimeterEnergyTrajectories = {};
    });
  }

  private _selectedTrajectoryBuildingIds$ = new BehaviorSubject<number[]>([]);
  private _selectedTrajectoryPerimeterIds$ = new BehaviorSubject<number[]>([]);

  public readonly selectedTrajectoryBuildingIds$: Observable<number[]> =
    this._selectedTrajectoryBuildingIds$.asObservable();
  public readonly selectedTrajectoryPerimeterIds$: Observable<number[]> =
    this._selectedTrajectoryPerimeterIds$.asObservable();

  public get selectedTrajectoryBuildingIds(): number[] {
    return this._selectedTrajectoryBuildingIds$.getValue();
  }

  public setTrajectorySelection(buildingIds: number[], perimeterIds: number[]): void {
    this._selectedTrajectoryBuildingIds$.next(buildingIds);
    this._selectedTrajectoryPerimeterIds$.next(perimeterIds);
  }

  public _perimeterEnergyTrajectories: {[site_id: number]: Observable<KPI.PerimeterEnergyTrajectory[]>} = {};
  public getPerimeterEnergyTrajectories(site_id: number): Observable<KPI.PerimeterEnergyTrajectory[]> {
    if (!this._perimeterEnergyTrajectories[site_id]) {
      this._perimeterEnergyTrajectories[site_id] = this.apiService.get_perimeter_energy_trajectories({site_id}).pipe(
        shareReplay(1),
      );
    }
    return this._perimeterEnergyTrajectories[site_id];
  }

  public _refrigerantPerimeterEnergyTrajectories: {[site_id: number]: Observable<KPI.PerimeterEnergyTrajectory[]>} = {};
  public getRefrigerantPerimeterEnergyTrajectories(site_id: number): Observable<KPI.PerimeterEnergyTrajectory[]> {
    if (!this._refrigerantPerimeterEnergyTrajectories[site_id]) {
      this._refrigerantPerimeterEnergyTrajectories[site_id] = this.refrigerantTypeService._refrigerantFluidHasChanged$.pipe(
        switchMap(() => this.apiService.get_perimeter_energy_trajectories({site_id})),
        map((trajectories) => trajectories.filter((trajectory) => !!trajectory.refrigerant_type)),
        shareReplay(1),
      );
    }
    return this._refrigerantPerimeterEnergyTrajectories[site_id];
  }

  public getPerimetersEnergyAreaBySite(site_id: number): Observable<{[perimeterId: number]: number}> {
    return this.getPerimeterEnergyTrajectories(site_id).pipe(
      map((trajectories) => 
        trajectories.reduce((acc, trajectory) => 
          {
            acc[trajectory.perimeter] = trajectory.area as number;
            return acc;
          }, 
          {} as {[perimeterId: number]: number}
        )
      ),
    );
  }

  public deletePerimeterEnergyTrajectory(id: number): Observable<any> {
    return this.apiService.delete_perimeter_energy_trajectory(id);
  }

}
